import React from 'react';
import { Button, Form } from 'react-bootstrap';
import ReceptionModalShell, { ReceptionFormField, ReceptionModalSection } from '../ui/ReceptionModalShell';
import { ReceptionStatusBadge } from '../ui';
import { formatAppDateTime } from '../../../utils/appTimezone';
import { formatRdvServiceLabel } from '../rdvFormatters';

export default function RendezVousRegisterVisitModal({
  show,
  rdv,
  sites,
  visitSiteId,
  visitNote,
  saving = false,
  activeSiteName,
  onHide,
  onSiteChange,
  onNoteChange,
  onConfirm
}) {
  const patientName = rdv
    ? `${rdv.member_prenom || rdv.external_prenom || ''} ${rdv.member_nom || rdv.external_nom || ''}`.trim()
    : '';

  return (
    <ReceptionModalShell
      show={show}
      onHide={onHide}
      disableClose={saving}
      size="md"
      title="Enregistrer le passage"
      subtitle="Le RDV sera orienté automatiquement selon son type (médecin, dentiste, infirmerie)."
      footer={
        <>
          <Button variant="secondary" onClick={onHide} disabled={saving}>
            Annuler
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={saving || !visitSiteId}>
            {saving ? 'Enregistrement…' : 'Confirmer le passage'}
          </Button>
        </>
      }
    >
      {rdv ? (
        <>
          <ReceptionModalSection title="Créneau sélectionné">
            <div className="recv-rdv-register-summary">
              <div className="recv-rdv-register-summary__main">
                <strong>{patientName || 'Patient'}</strong>
                <span className="text-muted small">
                  {rdv.start_at ? formatAppDateTime(rdv.start_at) : '—'}
                  {rdv.reference ? ` · ${rdv.reference}` : ''}
                </span>
              </div>
              <div className="recv-rdv-register-summary__badges">
                <ReceptionStatusBadge kind="rdvType" value={rdv.type_rendez_vous || 'AUTRE_SERVICE'} />
                <ReceptionStatusBadge kind="rdvStatus" value={rdv.status || 'EN_ATTENTE'} />
              </div>
              <div className="recv-rdv-register-summary__meta text-muted small">
                {formatRdvServiceLabel(rdv.service)}
                {rdv.motif ? ` · ${rdv.motif}` : ''}
              </div>
            </div>
          </ReceptionModalSection>

          <ReceptionModalSection title="Accueil">
            <ReceptionFormField label="Site de passage" required hint={activeSiteName ? `Site actif : ${activeSiteName}` : null}>
              <Form.Select value={visitSiteId} onChange={(e) => onSiteChange(e.target.value)} required>
                <option value="">Sélectionner…</option>
                {sites.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </Form.Select>
            </ReceptionFormField>
            <ReceptionFormField label="Note accueil (optionnel)">
              <Form.Control
                as="textarea"
                rows={2}
                value={visitNote}
                onChange={(e) => onNoteChange(e.target.value)}
                placeholder="Motif complémentaire, consigne…"
              />
            </ReceptionFormField>
          </ReceptionModalSection>
        </>
      ) : null}
    </ReceptionModalShell>
  );
}
